module.exports = __webpack_public_path__ + "static/media/reading-illustration.a4dad639.svg";